module.exports = __webpack_public_path__ + "img/n6.5f94656f.jpeg";